import { observable} from "mobx";
class HomeStore {
  @observable homeNum = 0;
}
export default HomeStore;